// extracted by mini-css-extract-plugin
module.exports = {"detailStyle":"hToa3nEOdji235cG5VxrY"};